import React, { useContext, useRef, useEffect, useMemo, useState } from 'react';
import { AppContext, AuthContext } from 'Context';
import { axios, dataFetcher, endpoints, baseUrl } from 'Api';
import useSWR from 'swr';
import Cancel from '../../../../Assets/delete.png';
import { StackedPreview } from './StackedPreview';
import DropDown from './DropDown';
import CreateNew from './CreateNew';
import RadioButtonsGroup from './RadioButton';
import styles from './Pubslish.module.css';

function GooglePublish({
  selectedCheckedItems,
  setDetailsData,
  detailsData,
  handleDetailsChange,
  thumbnailSelected,
  setThumbnailSelected,
  setSelectedCheckedItems,
  formatFileSize,
  addToProjector,
  type,
}) {
  const { getToken } = useContext(AuthContext);
  const [groups, setGroups] = useState(undefined);
  const [categrory, setCategrory] = useState(undefined);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const fetchCategories = async () => {
    try {
      const token = getToken(); // Get the token
      const response = await axios.post(
        `${baseUrl}/${endpoints.getMyCategories}`,
        {}, // Empty body for the POST request
        {
          headers: {
            Authorization: `Bearer ${token}`, // Token in Authorization header
          },
        }
      );
      // Check if the response is successful
      if (response?.data?.success) {
        setCategrory(
          response?.data?.data?.map(({ title: name, id: value }) => ({
            name,
            value,
          }))
        );
        // eslint-disable-next-line
      } else {
        console.error('Failed to fetch categories:', response.data.message);
        return [];
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  };
  const [newCategoryName, setNewCategoryName] = React.useState('');
  const handleSubmit = async (e, index) => {
    e.preventDefault();
    const payload = {
      category_id: '',
      icon: '1',
      title: newCategoryName,
      token: getToken(),
    };

    try {
      const response = await axios.post(`${baseUrl}/addEditCategory`, payload);

      // Wait for categories to be refreshed
      await fetchCategories(); // Make sure fetchCategories updates state synchronously or returns updated data

      // Find the matching category by title
      const createdCategory = categrory?.find(
        (cat) => cat.name === newCategoryName
      );
      console.log(
        'createdCategory',
        categrory,
        createdCategory,
        newCategoryName
      );
      if (createdCategory) {
        setDetailsData((prev) => ({
          ...prev,
          categrory: createdCategory?.value,
        }));
      }
      setOpen(false);
    } catch (error) {
      console.error('Error:', error);
      setOpen(false);
    }
  };

  const { isValidating: loadingGroups, mutate: fetchGroups } = useSWR(
    endpoints.getMyGroups,
    {
      onSuccess: ({ success, data }) => {
        if (success && data) {
          setGroups(data);
        } else {
          setGroups([]);
        }
      },
      onError: () => {
        setGroups([]);
      },
    }
  );
  const bottomRef = useRef(null);
  useEffect(() => {
    const index = selectedCheckedItems[0]?.pre_thumbnails?.findIndex((thumb) => thumb?.split('?')[0] === selectedCheckedItems[0]?.pre_thumbnail.split('?')[0]);
    setThumbnailSelected(index);
  }, []);

  useEffect(() => {
    if (addToProjector && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [addToProjector]);
  console.log('selectedCheckedItems', selectedCheckedItems, detailsData);
  return (
    <div>
      <div className={styles.preview}>
        {selectedCheckedItems?.length > 1 && (
          <button
            className={styles.clearButtonx}
            onClick={() => setSelectedCheckedItems([])}
          >
            <img src={Cancel} alt="" />
          </button>
        )}

{selectedCheckedItems?.length === 1 && type === 'photos' ? (
  <div className={styles.stackBox}>
    <img
      src={
        selectedCheckedItems[0]?.pre_thumbnail
        ?? selectedCheckedItems[0]?.baseUrl
      }
      alt=""
    />
  </div>
) : selectedCheckedItems?.length > 0 ? (
  <div className={styles.stackBox}>
    <StackedPreview
      type={type}
      items={selectedCheckedItems}
      setSelectedCheckedItems={setSelectedCheckedItems}
    />
  </div>
) : null}

        <div className={styles.previewContent}>
          {type === 'video' ? <h6>Video details</h6> : <h6>Album details</h6>}
          <div className={styles.info}>
            {type === 'video' ? (
              <span className={styles.label}>Video size</span>
            ) : (
              <span className={styles.label}>Album size</span>
            )}
            <span className={styles.value}>
              {formatFileSize(
                selectedCheckedItems?.reduce(
                  (acc, item) => acc + (item.size || 0),
                  0
                )
              )}
            </span>
          </div>
          {selectedCheckedItems?.length > 1 ? (
            <div className={styles.info}>
              <span className={styles.label}>Total Files</span>
              <span className={styles.value}>
                {selectedCheckedItems?.length}
              </span>
            </div>
          ) : (
            <div className={styles.info}>
              <span className={styles.label}>File Name</span>
              <span className={styles.value}>
                {selectedCheckedItems[0]?.name
                  || selectedCheckedItems[0]?.filename || selectedCheckedItems[0]?.mediaFile?.filename}
              </span>
            </div>
          )}
        </div>
      </div>
      {addToProjector
        && (type !== 'video' || selectedCheckedItems?.length === 1) && (
          <div ref={bottomRef}>
            <div className={styles.thumbnails}>
              <h5>Thumbnails</h5>
              <div className={styles.thumbnailsInner}>
                {selectedCheckedItems?.length > 0
                  && selectedCheckedItems[0]?.pre_thumbnails?.map((obj, index) => (
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => setThumbnailSelected(index)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          setThumbnailSelected(obj?.url);
                        }
                      }}
                      key={index}
                      className={styles.thumbnail}
                      style={{
                        border:
                          index === thumbnailSelected
                            ? '5px solid #5AA5EF'
                            : '1px solid transparent',
                      }}
                    >
                      <img src={obj} alt="Thumbnail" />
                    </div>
                  ))}
              </div>
            </div>
            <div className={styles.details}>
              <h5>Details</h5>
              <div className={styles.detailsFirst}>
                <span>File Name</span>
                <input
                  type="text"
                  name="title"
                  value={detailsData.title}
                  onChange={handleDetailsChange}
                  placeholder={
                    type === 'video'
                      ? 'Add a title to your video'
                      : 'Add a title to your photo album'
                  }
                />
              </div>
              <div className={styles.detailsSecond}>
                <span>Description</span>
                <textarea
                  name="description"
                  value={detailsData?.description}
                  onChange={handleDetailsChange}
                  placeholder={
                    type === 'video'
                      ? 'Short Lens view of your video'
                      : 'Short Lens view of your album'
                  }
                  rows={5}
                />
              </div>
            </div>
            {type === 'video' && (
              <DropDown
                handleOpen={handleOpen}
                selectedData={detailsData.categrory}
                setSelectedData={(value) => setDetailsData((prev) => ({
                    ...prev,
                    categrory: value,
                  }))}
                apiCall={fetchCategories}
                data={categrory}
              />
            )}
            <CreateNew
              handleSubmit={handleSubmit}
              open={open}
              setNewCategoryName={setNewCategoryName}
              setOpen={setOpen}
            />
            <RadioButtonsGroup
              apiCall={fetchGroups}
              data={groups}
              selectedData={detailsData.visibility}
              setSelectedData={(value) => setDetailsData((prev) => ({
                  ...prev,
                  visibility: value,
                }))}
              selectedGroups={detailsData.group}
              setSelectedGroups={(groups) => setDetailsData((prev) => ({ ...prev, group: groups }))}
            />
          </div>
        )}
    </div>
  );
}

export default GooglePublish;
